export const CONDITION_OPERATORS = [
  "=",
  "!=",
  ">",
  "<",
  ">=",
  "<=",
  "LIKE",
  "ILIKE",
  "IN",
  "ISNULL",
  "ISNOTNULL",
];

/** Default rows for AI payment-reminder campaigns (unassigned filter is enforced server-side). */
export const PAYMENT_REMINDER_DEFAULT_ROWS = [
  { mode: "object", expression: "", field: "targetOutstanding", operator: ">", value: "0" },
  { mode: "object", expression: "", field: "called", operator: "=", value: "false" },
];

export const buildPaymentReminderDefaultCondition = () =>
  serializeTriggerCondition({
    logic: "AND",
    limit: 50,
    rows: PAYMENT_REMINDER_DEFAULT_ROWS,
  });

export const createEmptyConditionRow = () => ({
  mode: "object",
  expression: "",
  field: "",
  operator: "=",
  value: "",
});

const shouldIgnoreValue = (operator) => ["ISNULL", "ISNOTNULL"].includes(operator);

const parseValue = (operator, value) => {
  if (shouldIgnoreValue(operator)) return undefined;
  if (operator === "IN" && typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }
  if (value === "") return "";
  const numericValue = Number(value);
  if (!Number.isNaN(numericValue) && value !== null && value !== undefined && `${value}`.trim() !== "") {
    return numericValue;
  }
  return value;
};

export const parseTriggerConditionRows = (triggerCondition) => {
  if (!triggerCondition || typeof triggerCondition !== "object") {
    return { logic: "AND", limit: "", rows: [createEmptyConditionRow()] };
  }
  const logic = triggerCondition.logic || "AND";
  const limit = triggerCondition.limit ?? "";
  const conditions = Array.isArray(triggerCondition.conditions)
    ? triggerCondition.conditions
    : [];
  const rows = conditions.length
    ? conditions.map((item) => {
        if (typeof item === "string") {
          return {
            mode: "string",
            expression: item,
            field: "",
            operator: "=",
            value: "",
          };
        }
        const rawValue = item?.value;
        const value =
          rawValue == null
            ? ""
            : Array.isArray(rawValue)
              ? rawValue.join(", ")
              : String(rawValue);
        return {
          mode: "object",
          expression: "",
          field: item?.field || "",
          operator: item?.operator || "=",
          value,
        };
      })
    : [createEmptyConditionRow()];
  return { logic, limit, rows };
};

export const serializeTriggerCondition = ({ logic, limit, rows }) => {
  const conditions = rows
    .map((row) => {
      if (row.mode === "string") {
        return row.expression?.trim() || null;
      }
      if (!row.field?.trim() || !row.operator?.trim()) return null;
      return {
        field: row.field.trim(),
        operator: row.operator.trim(),
        value: parseValue(row.operator, row.value),
      };
    })
    .filter(Boolean);

  return {
    logic: logic || "AND",
    limit: Number(limit) > 0 ? Number(limit) : undefined,
    conditions,
  };
};
